import {EventTypes, EventValues, EventCategories, SCHEDULER} from "../../utils/constants";
import {buildUri} from "../../utils/dom";
import {includeJSPromise} from "../../utils/script";
import {generateUUID} from "../../utils/guid";

export class AnalyticsService {

    #sessionIdentifier;
    #panelIdentifier;
    #engagementStage;

    set sessionGUID(guid){
        this.#sessionIdentifier = guid;
    }

    constructor() {
        this.#panelIdentifier = null;
        this.#sessionIdentifier = null;
        this.#engagementStage = SCHEDULER;
    }

     loadAnalytics() {
        this.#engagementStage = SCHEDULER;
        //try to load analytics library here
        //create promise to load analytics js file,once js file loaded then assign it to analytics object
        //Load script for Vee24 Analytics
        const url = buildUri(v24Scheduler.staticDomain, '/v24/veedesk/js/vee24-analytics.js');
        includeJSPromise(url).then(() => {
            if (window.v24Analytics !== undefined) {
                console.info('vee24Analytics library loaded successfully');
            }
        }).catch((err) => console.warn('Unable to load Analytics Library', err));

    }

    send(eventType, eventValue, panelType, eventData = {}) {
        if (!window.v24Analytics) {
            return;
        }
        if (eventValue !== undefined) {
            //generate guid when panel is opened
            if ((eventValue === EventValues.Show) && this.#panelIdentifier === null) {
                this.#panelIdentifier = generateUUID();
            }
            if (panelType === null){ // front-end library is typed string, so null = empty string ""
                panelType = "";
            }

            this.#sendAnalyticsEvent(eventType, eventValue, panelType, eventData);

            //remove panel identifier after panel closed but only after sending event
            if (eventType === EventTypes.PanelStateChange && eventValue === EventValues.Hide) {
                this.#panelIdentifier = null;
            }
        }
        console.info(`Analytics Event: ${eventType}, ${eventValue}, ${panelType}, ${eventData}`);

    }

    #sendAnalyticsEvent(eventType, eventValue, panelType, eventData= {}) {
        const evtName = this.#getEventName(eventType, eventValue);
        const evt= {
            type: eventType,
            category: this.#getEventCategory(eventType),
            engagementStage: this.#engagementStage,
            value: eventValue,
            sessionId: this.#sessionIdentifier,
            panelId: this.#panelIdentifier,
            sourcePanel: panelType,
            data: eventData
        };

        window.v24Analytics.send(evtName, evt);
    }

    /*
     * Maps category {@link EventCategories | EventCategories} to event type {@link EventTypes | `EventTypes`}
     */
    #getEventCategory(eventType)  {
        switch (eventType) {
            case EventTypes.PanelView:
                return EventCategories.View;
            case EventTypes.CTAClick:
            case EventTypes.Click:
            case EventTypes.Close:
                return EventCategories.Action;
            default:
                return EventCategories.NonInteraction;
        }

    }

     #getEventName(eventType, eventValue) {
        if (typeof eventValue === 'string' && eventValue.length > 0) {
            //capitalise for consistency
            eventValue = eventValue[0].toUpperCase() + eventValue.slice(1);
            eventValue = eventValue.replace(/\s/g, "-");
        }

        return `${eventType}_${eventValue}`;
    }
}
